import {
  Calculator,
  Landmark,
  HeartPulse,
  Cpu,
  Wrench,
  HardHat,
  GraduationCap,
  Scale,
  Megaphone,
  ShoppingBag,
  Plane,
  Truck,
  Zap,
  Building2,
  FlaskConical,
  Briefcase,
  Users,
  Newspaper,
  Factory,
  Antenna,
  Shield,
  Hammer,
} from "lucide-react";

const INDUSTRIES = [
  { name: "Accounting & Audit", icon: Calculator },
  { name: "Finance & Banking", icon: Landmark },
  { name: "Healthcare & Medical", icon: HeartPulse },
  { name: "Technology & IT", icon: Cpu },
  { name: "Engineering", icon: Wrench },
  { name: "Construction & Real Estate", icon: HardHat },
  { name: "Education & Academia", icon: GraduationCap },
  { name: "Legal", icon: Scale },
  { name: "Marketing, PR & Advertising", icon: Megaphone },
  { name: "Sales & Business Development", icon: Briefcase },
  { name: "HR & Recruitment", icon: Users },
  { name: "Retail & E-commerce", icon: ShoppingBag },
  { name: "Hospitality & Travel", icon: Plane },
  { name: "Media & Creative", icon: Newspaper },
  { name: "Manufacturing & Operations", icon: Factory },
  { name: "Logistics & Supply Chain", icon: Truck },
  { name: "Energy & Utilities", icon: Zap },
  { name: "Public Sector & Government", icon: Building2 },
  { name: "Pharmaceutical & Life Sciences", icon: FlaskConical },
  { name: "Telecommunications", icon: Antenna },
  { name: "Insurance", icon: Shield },
  { name: "Aerospace, Defence & Automotive", icon: Hammer },
];

export default function Industries() {
  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="py-24 md:py-32 bg-muted/40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <p className="label-eyebrow">Industries we cover</p>
          <h2 className="font-serif text-3xl md:text-5xl font-bold mt-3 leading-[1.05]">
            Expert CV writers for every UK industry.
          </h2>
          <p className="mt-4 text-foreground/70 leading-relaxed">
            From NHS clinicians to City bankers and Silicon Roundabout
            engineers — we write CVs for every major UK sector. Don't see
            yours? It's still covered.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {INDUSTRIES.map((ind) => (
            <div
              key={ind.name}
              data-testid={`industry-${ind.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="group flex items-center gap-3 rounded-2xl border border-border bg-card px-4 py-3.5 hover:border-foreground/30 hover:shadow-md transition"
            >
              <span className="h-9 w-9 rounded-lg bg-brand/10 text-brand flex items-center justify-center group-hover:bg-brand group-hover:text-white transition shrink-0">
                <ind.icon className="h-4 w-4" />
              </span>
              <span className="text-sm font-medium leading-tight">
                {ind.name}
              </span>
            </div>
          ))}
        </div>

        <p className="mt-10 text-center text-sm text-muted-foreground">
          Specialised role or niche industry? Mention it in your brief —
          we'll match you with a writer with sector experience.
        </p>
      </div>
    </section>
  );
}
